<!-- app.component.html -->
<ion-app>
  <div class="flex flex-col h-screen" *ngIf="isDesktop === true">
    <!-- Fixed Header -->
    <ion-header class="ion-no-border">
      <ion-toolbar class="px-4 shadow-md">
        <div class="container mx-auto flex items-center justify-between py-2">
          <ion-buttons slot="start">
            <a [routerLink]="['/desktop-home']" class="flex items-center">
              <img src="/assets/logo.png" alt="Logo" class="h-8 mr-4" />
            </a>
          </ion-buttons>

          <ion-buttons slot="end" class="space-x-6">
            <ion-button
              [routerLink]="['/desktop-home']"
              fill="clear"
              class="text-gray-700 hover:text-blue-600"
            >
              Home
            </ion-button>
            <ion-button
              [routerLink]="['/points-of-interest']"
              fill="clear"
              class="text-gray-700 hover:text-blue-600"
            >
              Punti di interesse
            </ion-button>
            <ion-button
              [routerLink]="['/itineraries']"
              fill="clear"
              class="text-gray-700 hover:text-blue-600"
            >
              Itinerari
            </ion-button>
            <ion-button
              [routerLink]="['/privacy']"
              fill="clear"
              class="text-gray-700 hover:text-blue-600"
            >
              Privacy
            </ion-button>
          </ion-buttons>
        </div>
      </ion-toolbar>
    </ion-header>

    <!-- Content Area -->
    <ion-content [fullscreen]="true" [scrollY]="true">
      <ion-router-outlet></ion-router-outlet>
    </ion-content>

    <!-- Fixed Footer -->
    <ion-footer class="ion-no-border">
      <ion-toolbar class="p-0 bg-white">
        <div class="flex items-center justify-center bg-white h-20 w-full">
          <img
            src="/assets/footer.jpg"
            alt="footer"
            class="max-h-full max-w-full object-contain"
          />
        </div>
      </ion-toolbar>
    </ion-footer>
  </div>
  <div class="flex flex-col h-screen" *ngIf="isDesktop === false">
    <ion-header class="ion-no-border">
      <ion-toolbar class="px-4 shadow-md">
        <div class="container mx-auto flex items-center justify-between py-2">
          <ion-buttons slot="start">
            <a [routerLink]="['/desktop-home']" class="flex items-center">
              <img src="/assets/logo.png" alt="Logo" class="h-8 mr-4" />
            </a>
          </ion-buttons>

          <ion-buttons slot="end" class="space-x-6">
            <ion-button
              [routerLink]="['/']"
              fill="clear"
              class="text-gray-700 hover:text-blue-600"
            >
              Home
            </ion-button>
            <ion-button
              [routerLink]="['/privacy']"
              fill="clear"
              class="text-gray-700 hover:text-blue-600"
            >
              Privacy
            </ion-button>
          </ion-buttons>
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content [fullscreen]="true" [scrollY]="true">
      <ion-router-outlet></ion-router-outlet>
    </ion-content>
    <ion-footer class="ion-no-border">
      <ion-toolbar class="p-0 bg-white">
        <div class="flex items-center justify-center bg-white h-20 w-full">
          <img
            src="/assets/footer.jpg"
            alt="footer"
            class="max-h-full max-w-full object-contain"
          />
        </div>
      </ion-toolbar>
    </ion-footer>
  </div>
</ion-app>
